import { useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import {
  Breakpoint,
  GRID_COLUMN_GAP_MEDIUM,
  GRID_COLUMN_GAP_SMALL,
  GRID_COLUMN_GAP_XLARGE,
  useBreakpoint,
} from '@noths/polaris-client-ribbons-base';

export const SMALL_SCREEN_COLUMN_GAP = GRID_COLUMN_GAP_SMALL;
export const MEDIUM_SCREEN_COLUMN_GAP = GRID_COLUMN_GAP_MEDIUM;
export const XLARGE_SCREEN_COLUMN_GAP = GRID_COLUMN_GAP_XLARGE;

export const useGridColumnGap = () => {
  const [columnGap, setColumnGap] = useState(GRID_COLUMN_GAP_XLARGE);
  const breakpoint = useBreakpoint({ initializeWithLarge: true });

  useIsomorphicLayoutEffect(() => {
    switch (breakpoint) {
      case Breakpoint.XXS:
      case Breakpoint.XS:
      case Breakpoint.S:
        setColumnGap(SMALL_SCREEN_COLUMN_GAP);
        break;
      case Breakpoint.M:
      case Breakpoint.L:
        setColumnGap(MEDIUM_SCREEN_COLUMN_GAP);
        break;
      default:
        setColumnGap(XLARGE_SCREEN_COLUMN_GAP);
    }
  }, [breakpoint]);

  return columnGap;
};
